var box = require('./box');
var particle = require('./particle');
var Shrapnel = require('./shrapnel');
var PIXI = require('pixi.js');

var Rocket = function(game, x, y, a) {
    this.game = game;
    this.x = x;
    this.y = y;
    this.a = a;
    this.sprite = new PIXI.Sprite(this.game.textures.ship);
    this.sprite.scale.set(.37, .37);
    this.sprite.position.x = this.x;
    this.sprite.position.y = this.y;
    this.sprite.anchor.x = 0.5;
    this.sprite.anchor.y = 0.5;
    this.pointer = new PIXI.Sprite(this.game.textures.pointer);
    this.pointer.position.set(100 * this.game.scale, 0);
    this.pointer.rotation = -Math.PI;
    this.pointer.scale.set(.2);
    this.pointer.anchor.set(.5, 1);
    this.pointer.visible = false;
    this.rocketScale = .37;
    this.my = 0;
    this.go = false;
    this.flame = {
        left: new PIXI.Sprite(this.game.textures.thrust),
        right: new PIXI.Sprite(this.game.textures.thrust),
        bottom: new PIXI.Sprite(this.game.textures.thrust),
    };
    this.heightGraph = new PIXI.Graphics();
    this.flame.left.anchor.x = .5;
    this.flame.left.anchor.y = .5;
    this.flame.right.anchor.x = .5;
    this.flame.right.anchor.y = .5;
    this.flame.bottom.anchor.x = .5;
    this.flame.bottom.anchor.y = .5;
    this.game.stage.addChild(this.flame.left);
    this.game.stage.addChild(this.flame.right);
    this.game.stage.addChild(this.flame.bottom);
    this.game.stage.addChild(this.heightGraph);
    this.game.stage.addChild(this.pointer);
    this.flame.bottom.scale.x = .8;
    this.flame.bottom.scale.y = .8;
    this.flame.left.scale.set(.2, .2);
    this.flame.right.scale.set(.2, .2);
    this.start = Date.now();
    this.makeBody(x, y);
    this.active = true;
    this.last_particle = Date.now();
    this.last_shot = Date.now();
    this.fuel = 0;
    this.impact_points = {};
    this.body.SetPosition(new box.Vec2(this.game.width / 2 / this.game.scale, (this.game.height - 18) / this.game.scale));
    this.game.stage.addChild(this.sprite);
    this.gp_thrust = false;
    this.gp_left = false;
    this.gp_right = false;
    this.explosionSprite = null;
    this.gamepads = {};
    var rocket = this;

    function gamepadHandler(event, connecting) {
        var gamepad = event.gamepad;

        if (connecting) {
            rocket.gamepads[gamepad.index] = gamepad;
            console.log("new gamepad %o", rocket.gamepads);
        } else {
            delete rocket.gamepads[gamepad.index];
            console.log("gamepad unpluged");
        }
    }

    window.addEventListener("gamepadconnected", function(e) { gamepadHandler(e, true); }, false);
    window.addEventListener("gamepaddisconnected", function(e) { gamepadHandler(e, false); }, false);

    if (false && this.game.mobile) {
        window.addEventListener("deviceorientation", function (e) {
            if ((e.gamma < -15 && e.gamma > -45) || (e.gamma < -105 && e.gamma > -140)) {
                this.gp_left = true;
            } else {
                this.gp_left = false;
            }
            if ((e.gamma > 15 && e.gamma < 45) || (e.gamma > 105 && e.gamma < 140)) {
                this.gp_right = true;
            } else {
                this.gp_right = false;
            }
        }.bind(this));
    }

};

(function () {

    this.makeBody = function (x, y) {
        this.body = this.game.makeBody({x: x, y: y, points: [
            [-.6,-1.3],
            [-.5,-1.5],
            [0, -1.8],
            [.5,-1.5],
            [.6,-1.3],
            [1.2,.7],
            [.9,1.8],
            [-.9,1.8],
            [-1.2,.7],
        ], density: .75, parent: this});
    };

    this.explode = function() {
        if(!this.active) { return; }
        this.game.msgFlash.text.position.set(this.game.width / 2, this.game.height / 2);
        this.game.scoreText.visible = false;
        if (!this.game.mobile) {
            this.game.msgFlash.set("Score: " + this.game.score + "\nHiScore: " + this.game.hi_score + "\n\nPress \"R\" to Restart", 0, 'hold', this.game.width / 2, this.game.height - 90);
        } else {
            this.game.msgFlash.set("Score: " + this.game.score + "\n\n\n\nTap Reset to Restart", 0, 'hold');
        }
        this.game.options.events({event: 'game_over', score: this.game.score, hi_score: this.game.hi_score});
        Object.keys(this.flame).forEach(function (fname) {
            this.flame[fname].visible = false;
        }.bind(this));
        if (!this.game.audio.explode.isEnded()) {
            this.game.audio.explode.stop();
        }
        if (this.game.shouldPlayAudio()) {
            this.game.audio.explode.play();
        }
        this.fuel = 0;
        this.game.touchgoal = 0;
        this.game.get_events = {};
        //this.game.newGoal();
        var pos = this.body.GetPosition();
        var vel = this.body.GetLinearVelocity();
        var idx = 0;
        var a = Math.random() * Math.PI * 2;
        while(idx < 10) {
            idx++;
            var s = new Shrapnel(this.game, pos.x + Math.sin(a) * 2, pos.y + Math.cos(a) * 2, .01, false);
            s.body.SetAngularVelocity(Math.random() * 50 - 25);
            var af = Math.random() *100 + 30;
            var f = new box.Vec2(Math.sin(a) * af, Math.cos(a) * af);
            s.body.ApplyImpulse(f, pos);
            this.game.shraps.push(s);
            a += Math.PI/5;
            if (a > Math.PI * 2) a = a - Math.PI * 2;
        }
        [0,200, 600].forEach(function (timeout) {
            setTimeout(function () {
                var explosion = new PIXI.extras.MovieClip(this.game.explosion);
                explosion.anchor.x = .5;
                explosion.anchor.y = .5;
                explosion.position.x = pos.x * this.game.scale + Math.random() * 100 - 50;
                explosion.position.y = pos.y * this.game.scale + Math.random() * 100 - 50;
                explosion.loop = false;
                explosion.animationSpeed = .21;
                explosion.rotation = Math.random() * Math.PI;
                explosion.scale.x = explosion.scale.y = 0.75 + Math.random() * 0.5;
                explosion.play();
                explosion.onComplete = function () {
                    explosion.stop();
                    setTimeout(function () {
                        this.game.stage.removeChild(explosion);
                    }.bind(this));
                }.bind(this);
                this.game.stage.addChild(explosion);
            }.bind(this), timeout);
        }.bind(this));
        this.game.platform.goal.destroy();
        delete this.game.platform.goal;
        this.game.world.DestroyBody(this.body);
        this.active = false;
        this.hit = 0;
        this.scraping = 0;
        this.game.stage.removeChild(this.sprite);
    };

    this.reset = function (subtractPoints) {
        this.game.still = 0;
        this.game.stillcycle = 0;
        this.game.scoreText.visible = true;
        var vel, msg;
        this.game.msgFlash.fadeOut();
        this.game.last_angle = 0;
        if (this.active) {
            if (this.speed < 1) {
                this.game.world.DestroyBody(this.body);
                if (subtractPoints) {
                    if (this.game.score > 0) {
                        this.game.options.events({event: 'reset'});
                        msg = "-500";
                    }
                    this.game.setScore(this.game.score - 500);
                }
            } else {
                return;
            }
        } else {
            this.game.options.events({event: 'new_game'});
            this.game.setScore(0);
            this.game.stage.addChild(this.sprite);
        }
        //this.body = this.game.makeBody({x: 800/2*this.game.scale, y: (600-20)/this.game.scale, points: [[0,-2],[1.5,1.5],[-1.5,1.5]], parent: this});
        this.makeBody(800/2*this.game.scale, (600-20)/this.game.scale);
        this.body.SetPosition(new box.Vec2(this.game.width / 2 / this.game.scale, (this.game.height - 18) / this.game.scale));
        this.body.SetAngle(0);
        this.body.SetAngularVelocity(0);
        this.body.SetLinearVelocity(new box.Vec2(0, 0));
        for(var s in this.game.shraps) {
            this.game.shraps[s].destroy();
        }
        this.game.shraps = [];
        this.active = true;
        this.game.newGoal(msg);
        this.game.msgFlash.text.visible = false;
        this.game.resume();
    };

    this.updateFlamePos = function (pos, ang) {
        var x = pos.x * this.game.scale;
        var y = pos.y * this.game.scale;
        this.flame.bottom.position.x = x - Math.sin(ang) * 36;
        this.flame.bottom.position.y = y + Math.cos(ang) * 36;
        this.flame.bottom.rotation = ang - Math.PI;
        this.flame.left.position.x = x + Math.sin(ang -.9) * 15;
        this.flame.left.position.y = y + Math.cos(ang -.9) * -15;
        this.flame.left.rotation = ang - Math.PI;
        this.flame.right.position.x = x + Math.sin(ang +.9) * 15;
        this.flame.right.position.y = y + Math.cos(ang +.9) * -15;
        this.flame.right.rotation = ang;
        Object.keys(this.flame).forEach(function (fname) {
            this.flame[fname].alpha = Math.random() * .5 + .2;
        }.bind(this));
    };

    this.animate = function(dt, now) {
        Object.keys(this.gamepads).forEach(function (gpi) {
            var gp = this.gamepads[gpi];
            this.gp_thrust = false;
            this.gp_left = false;
            this.gp_right = false;
            if (gp.buttons[0].pressed || gp.buttons[1].pressed || gp.buttons[2].pressed || gp.buttons[3].pressed) {
                this.gp_thrust = true;
            }
            if (gp.buttons[13].pressed) {
                this.gp_left = true;
            }
            if (gp.buttons[14].pressed) {
                this.gp_right = true;
            }
            if (gp.buttons[8].pressed) {
                this.reset();
            }
        }.bind(this));
        if (this.hit !== this.game.frame) {
            this.game.audio.scrape.stop();
            this.hit = 0;
            this.scraping = 0;
        } else {
            this.scraping += 1;
            if (this.game.shouldPlayAudio() && this.scraping > 4) {
                this.game.audio.scrape.play().loop();
            }
            if (this.scraping > 10) {
                this.game.achieve.scraping = this.game.frame;
            }
        }

        if(this.active) {
            var angv = this.body.GetAngularVelocity();
            if(this.game.keys[88] == true) {
                this.explode();
                return;
            }
            var pos = this.body.GetPosition();
            if(pos.x * this.game.scale > this.game.width) {
                pos.x = 0;
                this.body.SetPosition(pos);
            } else if (pos.x < 0) {
                pos.x = this.game.width / this.game.scale;
                this.body.SetPosition(pos);
            }

            this.angle = this.game.normalizeAngle(this.body.GetAngle());
            this.updateFlamePos(pos.Copy(), this.angle);
            var vel = this.body.GetLinearVelocity();
            if(this.game.keys[32] === true) {
                if(now - this.last_shot > 100) {
                    var pos = this.body.GetPosition();
                    npos = pos.Copy();
                    var angle = this.body.GetAngle();
                    npos.x += Math.sin(angle) * 3.9;
                    npos.y -= Math.cos(angle) * 3.9;
                    var force = new box.Vec2(Math.sin(angle) * 340, Math.cos(angle) * -340);
                    var s = new Shrapnel(this.game, npos.x, npos.y, 0, false, true, false);
                    //s.body.SetAngularVelocity(Math.random() * 50 - 25);
                    s.body.SetLinearVelocity(vel);
                    s.body.ApplyImpulse(force, s.body.GetPosition());
                    s.body.SetAngle(this.angle);
                    this.game.shraps.push(s);
                    this.last_shot = now;
                }
            }
            if((this.game.keys[38] === true || this.gp_thrust) && !this.game.paused) {
                this.game.msgFlash.fadeOut();
                var cp = pos.Copy();
                cp.x += Math.sin(this.angle) * -2.4;
                cp.y += Math.cos(this.angle) * 2.4;
                var force = new box.Vec2(Math.sin(this.angle), Math.cos(this.angle))
                force.x *= dt / 2.5;
                force.y *= -dt / 2.5;
                this.body.ApplyImpulse(force, cp);

                vel = this.body.GetLinearVelocity();

                if (this.game.shouldPlayAudio()) {
                    this.game.audio.rocket.play().loop();
                    this.game.audio.rocket.setVolume(20);
                }
                //this.flame.bottom.visible = true;
                var p = new particle.Particle(this.game, this.game.textures.flame);
                var a = this.angle + (Math.random() * .2) - .1;
                p.reset(
                    cp.x * this.game.scale,
                    cp.y * this.game.scale,
                    Math.sin(a) * -(70 + (100 * Math.random())) + vel.x,
                    Math.cos(a) *(70 + (100 * Math.random())) + vel.y,
                    .13, -.5, 1, 0,
                    Math.random() * 360,
                    Math.random() * 10 - 5);
            } else {
                this.flame.bottom.visible = false;
                this.game.audio.rocket.stop();
            }
            if(this.game.keys[39] === true || this.gp_right) {
                var cp = pos.Copy();
                var force = 1.7;
                if (Math.abs(angv) < .1 && cp.y * this.game.scale > this.game.height - 50 && this.angle > 3.8 && this.angle < 4.8) {
                  force = 200;
                }
                cp.x -= Math.sin(this.angle) * -1 * force;
                cp.y -= Math.cos(this.angle) * force;
                var force = new box.Vec2(Math.sin(this.angle + Math.PI/2) * .025 * dt, Math.cos(this.angle - Math.PI/2) * .02 * dt)
                this.body.ApplyImpulse(force, cp);
                this.flame.left.visible = true;
            } else {
                this.flame.left.visible = false;
            }
            if(this.game.keys[37] == true || this.gp_left) {
                var cp = pos.Copy();
                var force = 1.7;
                if (Math.abs(angv) < .1 && cp.y * this.game.scale > this.game.height - 50 && this.angle > 1.8 && this.angle < 1.9) {
                  force = 200;
                }
                cp.x += Math.sin(this.angle) * force;
                cp.y += Math.cos(this.angle) * -1 * force;
                var force = new box.Vec2(Math.sin(this.angle - Math.PI/2) * .025 * dt, Math.cos(this.angle + Math.PI/2) * .02 * dt)
                this.body.ApplyImpulse(force, cp);
                this.flame.right.visible = true;
            } else {
                this.flame.right.visible = false;
            }
            this.x = pos.x * this.game.scale;
            this.y = pos.y * this.game.scale;
            if (pos.y < -3) {
              this.pointer.position.set(this.x, 0);
              this.pointer.visible = true;
              this.sprite.scale.set(this.rocketScale * .5);
              this.sprite.position.y = 4.5 * this.game.scale;
              this.heightGraph.clear();
              this.heightGraph.visible = true;
              this.heightGraph.beginFill(0xEC008C);
              this.heightGraph.drawRect((pos.x + 2) * this.game.scale, 5.5 * this.game.scale, 10, Math.max(this.y * .125, -5 * this.game.scale));
            } else {
              this.pointer.visible = false;
              this.heightGraph.visible = false;
              this.sprite.scale.set(this.rocketScale);
              this.sprite.position.y = this.y;
            }
            this.sprite.position.x = this.x;
            this.sprite.rotation = this.angle;
            if (vel.x === 0 && vel.y === 0) {
              this.my += dt;
            } else {
              this.my = 0;
            }
            if (this.my > 2000) {

              console.log("Angle:", this.angle)
              this.game.msgFlash.text.position.set(this.x, this.y - 40);
              this.game.msgFlash.set('Press \"R\" to Reset');
              this.my = 0;
              this.game.pause();
            }
        } else {
            this.game.audio.rocket.stop();
        }
    };
}).call(Rocket.prototype);

module.exports = Rocket;



//////////////////
// WEBPACK FOOTER
// ./src/rocket.js
// module id = 93
// module chunks = 0